import React from 'react';
import './PostTypeModal.css';

const PostTypeModal = ({ currentLanguage, getLocalizedText, onClose, onSelectRoom, onSelectProfile }) => {
  const t = (ar, en) => getLocalizedText(ar, en);

  return (
    <div 
      className="post-type-modal-overlay" 
      onClick={onClose}           // ← ضغط على الخلفية يقفل المودال
    >
      <div 
        className={`post-type-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`}
        onClick={(e) => e.stopPropagation()}   // ← منع إغلاق المودال لو ضغط جوا
      >

        <div className="post-type-options">
          
          {/* Room Card */}
          <div className="post-type-card-room">
            <div className="post-type-content">
              <h3>{t('تبحث عن شريك سكن؟', 'Need a roommate?')}</h3>
              <button className="post-type-btn" onClick={onSelectRoom}>
                {t('انشر إعلان الغرفة', 'Post your room ➜')}
              </button>
            </div>
            <div className="post-type-icon-house">
              <img src="/assets/house.png"/>
            </div>
          </div>

          {/* Profile Card */}
          <div className="post-type-card-profile">
            <div className="post-type-content">
              <h3>{t('تبحث عن فريق للسكن؟', 'Looking for a Team-Up?')}</h3>
              <button className="post-type-btn" onClick={onSelectProfile}>
                {t('كون فريقك من هنا', 'Create your Team ➜')}
              </button>
            </div>
            <div className="post-type-icon-team">
              <img src="/assets/profile.png" />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PostTypeModal;